import { IS_DEV } from "@/constants"
import { configureStore as rtkConfigureStore } from "@reduxjs/toolkit"
import { MIDDLEWARES } from "middleware/rootMiddleware"
import { REDUCERS } from "reducers/rootReducer"

const configureStore = (preloadedState = {}) =>
  rtkConfigureStore({
    reducer: REDUCERS,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActionPaths: ["error", "success"],
        },
      }).concat(MIDDLEWARES),
    preloadedState,
    devTools: IS_DEV,
  })

export default configureStore
